export default __webpack_public_path__ + "static/media/fast-and-efficient-new.cd828c9a.png";